module.exports = __webpack_public_path__ + "img/table_caigoufukuan.b231f99a.png";